import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import SongTrackLoader from '../../components/loader/songTrackLoader';
import MonthlyTopSongs from '../../components/monthlyTopSongs/monthlyTopSongs';
import RightSide from "../../components/rightSide/rightSide";
import SongTrack from '../../components/songTrack/songTrack';
import MusicDashboard from '../../layouts/musicDashboard';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { connect } from 'react-redux';

import * as songActions from '../../store/song/actions';

const SECTION_LABELS = {
    recommended_for_you: 'Recommended For You',
    trending_today: 'Trending Today',
    trending_week: 'Trending This Week',
    trending_month: 'Trending This Month',
    new_releases: 'New Releases',
    similar_to_recent: 'Similar To Your Recent Downloads',
    hidden_gems: 'Hidden Gems',
    collaborative: 'Users With Similar Taste Also Downloaded',
};

// Full (up to 20) view of a single recommendation section — the "View All"
// destination for the capped-preview rails on the home page
// (components/homeRecommendationSection). No pagination: each section is a
// precomputed, curated top-20 list, not a paginated browse.
const RecommendationSection = ({ loggingIn, getSectionRecommendations, sectionRecommendations, displayLoading, hideLoading }) => {

    let match = useParams("/mp3/recommendation/:section");
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        loadData();
        window.scrollTo({ top: 0 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match.section]);

    const loadData = async () => {
        displayLoading();
        setProcessing(true);
        await getSectionRecommendations(match.section);
        hideLoading();
        setProcessing(false);
    }

    // mapStateToProps can't see useParams() (it runs outside the component
    // body), so the whole sectionRecommendations map is selected and
    // indexed here instead, where match.section is available.
    const sectionData = sectionRecommendations ? sectionRecommendations[match.section] : null;
    const songs = sectionData && sectionData.songs ? sectionData.songs : [];
    const title = SECTION_LABELS[match.section] || 'Recommended';

    return (
        <MusicDashboard rightContent={<RightSide blocks={{ top30TrendingTracks: true }} />}>
            <div className="content-sec">
                <MonthlyTopSongs />
                <div className="play-list-sec">
                    <div className="top-heading">
                        <h2>{title}</h2>
                    </div>
                    <div className="inner-block">
                        {processing ? <SongTrackLoader itemCount={20} /> : <SongTrack songs={songs} sectionName={`recommendation-${match.section}`} displayDates={true} />}
                    </div>
                </div>
            </div>
        </MusicDashboard>
    );
}

function mapStateToProps(state) {
    return {
        loggingIn: state.authentication.loggedIn,
        sectionRecommendations: state.song.sectionRecommendations,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getSectionRecommendations: (section) => dispatch(songActions.getSectionRecommendations(section)),
        displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
        hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RecommendationSection);
